import React from 'react';
import { RocketIcon, CalendarDaysIcon, BarChart3Icon, RepeatIcon, UtensilsIcon, TagIcon, GiftIcon } from 'lucide-react';
import { bonos } from '../data/bonos';
const icons = {
  rocket: RocketIcon,
  calendar: CalendarDaysIcon,
  chart: BarChart3Icon,
  repeat: RepeatIcon,
  utensils: UtensilsIcon,
  tag: TagIcon
};
export function BonosSection() {
  return <section className="w-full bg-white py-16 sm:py-20" aria-labelledby="bonos-title" data-id="element-19" data-mp="tfqb5jcnqzdw">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-20" data-mp="tddlek0nrkqa">
        <div className="max-w-3xl" data-id="element-21" data-mp="ofvk9fsvu9su">
          <GiftIcon className="h-8 w-8 text-cta" aria-hidden="true" data-id="element-22" data-mp="oizvgx4rm5t0" />
          <h2 id="bonos-title" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl lg:text-5xl" data-id="element-23" data-mp="kflea353bjdz">
            6 bonos estratégicos — incluidos siempre, sin costo extra
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-body" data-id="element-24" data-mp="29tq9ipvuugz1">
            Porque las recetas son el inicio. Lo que hace que el sistema funcione de verdad son las
            herramientas que lo sostienen en el tiempo.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="vsek3wbx4qvp">
          {bonos.map(bono => {
          const Icon = icons[bono.icon];
          return <li key={bono.number} className="flex flex-col rounded-2xl border border-beige-deep bg-cream p-6 transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-lg" data-id="element-26" data-mp="mum56ta3zl8u">
                <div className="flex items-center gap-3" data-id="element-27" data-mp="10tu2fgmpojae">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-sage text-white" data-id="element-28" data-mp="10tc0c3ddbauk">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-29" data-mp="15qkm0dxq5x0k" />
                  </span>
                  <span className="font-display text-xs font-bold uppercase tracking-[0.12em] text-body-muted" data-id="element-30" data-mp="1tg6horew1u3t">
                    Bono {bono.number}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-lg font-bold leading-snug text-petrol" data-id="element-31" data-mp="2846rzd106fat">
                  {bono.title}
                </h3>
                <div className="mt-3 space-y-3 text-sm leading-relaxed text-body" data-id="element-32" data-mp="1y695atyskqkb">
                  {bono.body.map(paragraph => <p key={paragraph} data-id="element-33" data-mp="1t760namq4mcv">{paragraph}</p>)}
                </div>
                <p className="mt-auto pt-6 text-sm font-semibold text-petrol" data-id="element-34" data-mp="1p6vthun73pwf">
                  Valor: <span className="text-body-muted line-through" data-id="element-35" data-mp="1kech3108v0t7">{bono.value}</span>{' '}
                  <span className="text-sage-deep" data-id="element-36" data-mp="1ffhstjjick1p">GRATIS con tu MegaPack</span>
                </p>
              </li>;
        })}
        </ul>

        <p className="mt-12 rounded-3xl bg-petrol px-6 py-8 text-center font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-37" data-mp="1afd6vdztyx43">
          Valor total de bonos: <span className="text-white/60 line-through" data-id="element-38" data-mp="11ht3nzieqqqu">$53.000</span>{' '}
          <span className="text-cta" data-id="element-39" data-mp="3d4mwpotqlgdh">→ $0 con tu MegaPack.</span>
          <span className="mt-2 block text-base font-medium text-white/75" data-id="element-40" data-mp="3d67tzm7frdf1">
            Siempre incluidos. Sin condiciones.
          </span>
        </p>
      </div>
    </section>;
}